const collectionTab = document.querySelector(".collection-tab-section .collection");
const sectionIddd = collectionTab.getAttribute("data-id");
const cache = {};
if (collectionTab) {
  const collectionButtons = collectionTab.querySelectorAll('.collection-tab-list .button');
  const viewAllButton = collectionTab.querySelector('.collection__view-all .button');
  collectionButtons.forEach((button) => {
    const handle = button.dataset.collectionHandle;
   
    if (handle) {
      fetch(`${handle}/?section_id=${sectionIddd}`)
        .then((response) => response.text())
        .then((html) => {
          cache[handle] = html;
        });
    }
  });

  collectionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      
      collectionButtons.forEach((btn) => {
        btn.classList.remove('button--primary');
        btn.classList.add('button--secondary');
      });
      button.classList.add('button--primary');
      button.classList.remove('button--secondary');

      const selectedHandle = button.dataset.collectionHandle;
      // console.log('selectedHandle', selectedHandle);
      if (selectedHandle && cache[selectedHandle]) {
        console.log('selectedHandle1', selectedHandle);
        updateCollectionHTML(cache[selectedHandle]);
      } else if (selectedHandle) {
        fetch(`${selectedHandle}/?section_id=${sectionIddd}`)
          .then((response) => response.text())
          .then((html) => {
            cache[selectedHandle] = html;
            updateCollectionHTML(html);
          });
      }

      if (viewAllButton) {
        viewAllButton.setAttribute('href', selectedHandle);
      }
    });
  });
}

function updateCollectionHTML(responseText) {
  const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
  const collectionDataElement = responseHTML.querySelector(`#collection-data-${sectionIddd}`).innerHTML;
  document.getElementById('collection-data-' + sectionIddd).innerHTML = collectionDataElement;
}